import { z } from 'zod';

export const contactSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Please enter your name.')
    .max(100, 'Name is too long.'),
  email: z
    .string()
    .trim()
    .email('Please enter a valid email address.')
    .max(200, 'Email is too long.'),
  subject: z
    .string()
    .trim()
    .min(3, 'Please enter a subject.')
    .max(150, 'Subject is too long.'),
  message: z
    .string()
    .trim()
    .min(10, 'Please write a short message (at least 10 characters).')
    .max(5000, 'Message is too long.'),
  website: z.string().optional(),
});

export type ContactSchema = z.infer<typeof contactSchema>;
